import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Header } from '../../../../shared/components';
import { authService } from '../../services/auth/authService';
import '../../../../shared/styles/common.css';
import '../../../../shared/components/Header/Header.css';
import './LoginPage.css';

const AIHealthcareGraphic = () => (
  <svg
    className="login-left-graphic"
    viewBox="0 0 200 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <circle cx="100" cy="85" r="55" stroke="rgba(147, 197, 253, 0.5)" strokeWidth="0.8" fill="none" />
    <circle cx="100" cy="85" r="42" stroke="rgba(147, 197, 253, 0.35)" strokeWidth="0.6" fill="none" />
    {[45, 70, 100, 130, 155].map((y) => (
      <line key={y} x1="50" y1={y} x2="150" y2={y} stroke="rgba(147, 197, 253, 0.4)" strokeWidth="0.5" />
    ))}
    {[55, 75, 100, 125, 145].map((x) => (
      <line key={x} x1={x} y1="35" x2={x} y2="135" stroke="rgba(147, 197, 253, 0.4)" strokeWidth="0.5" />
    ))}
    {[60, 80, 100, 120, 140].map((x, i) =>
      [50, 70, 85, 100, 120].map((y, j) => (
        <circle key={`${i}-${j}`} cx={x} cy={y} r="2" fill="rgba(147, 197, 253, 0.8)" />
      ))
    )}
  </svg>
);

const ForgotPasswordPage: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (!email.trim()) {
      setError('Please enter your email address.');
      return;
    }

    try {
      setLoading(true);
      const respMessage = await authService.requestPasswordReset(email.trim());
      setMessage(respMessage);
    } catch (err) {
      console.error('Forgot password request error:', err);
      setMessage('If this email exists, a password reset link has been sent.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page-wrapper">
      <Header showDietitiansLink={false} />
      <div className="login-page">
        <div className="login-card">
          <div className="login-card-left">
            <AIHealthcareGraphic />
            <p className="login-card-left-line1">AI HEALTHCARE</p>
            <p className="login-card-left-line2">NETWORK</p>
          </div>

          <div className="login-card-right">
            <div className="login-brand">
              <img src="/images/zivo_logo.png" alt="Zivo" className="login-logo-img" />
            </div>
            <h1 className="login-title">Forgot your password?</h1>
            <p className="login-subtitle">
              Enter your registration email to receive instructions to change your password.
            </p>

            <div className="login-form-container">
              <form onSubmit={handleSubmit} className="login-form">
                <div className="form-group">
                  <label htmlFor="forgot-email">EMAIL ADDRESS</label>
                  <input
                    id="forgot-email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="you@hospital.com"
                    required
                    disabled={loading}
                  />
                </div>

                {error && <div className="error-message">{error}</div>}
                {message && !error && (
                  <div
                    style={{
                      background: '#ecfeff',
                      color: '#0f766e',
                      padding: '0.75rem 1rem',
                      borderRadius: 8,
                      fontSize: '0.875rem',
                      marginBottom: '1rem',
                      border: '1px solid #99f6e4',
                    }}
                  >
                    {message}
                  </div>
                )}

                <button type="submit" className="login-button" disabled={loading}>
                  {loading ? 'Sending...' : 'Send Reset Link'}
                </button>
              </form>

              <p className="signup-link">
                Remember your password?{' '}
                <Link
                  to="/login"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate('/login');
                  }}
                >
                  Back to sign in
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
